// Thu Mar 27 06:04:37 GMT 2025

import * as models from "../crm-web-api-models"

export enum SubscriptionProp {
	CreatedBy = 'createdBy',
	CreationTime = 'creationTime',
	Customer = 'customer',
	CustomerId = 'customer.id',
	Description = 'description',
	EndDate = 'endDate',
	Id = 'id',
	ModificationTime = 'modificationTime',
	ModifiedBy = 'modifiedBy',
	Status = 'status',
	SubscriptionDefinitionId = 'subscriptionDefinition.id',
	SubscriptionDefinitionName = 'subscriptionDefinition.name',
	SubscriptionDefinitionServiceType = 'subscriptionDefinition.serviceType'
}

export type SubscriptionPropCreatedBy = {
	[SubscriptionProp.CreatedBy] : models.UserDto | null
}
export type SubscriptionPropCreationTime = {
	[SubscriptionProp.CreationTime] : number | null
}
export type SubscriptionPropCustomer = {
	[SubscriptionProp.Customer] : models.DefaultEntityDto | null
}
export type SubscriptionPropCustomerId = {
	[SubscriptionProp.CustomerId] : number | null
}
export type SubscriptionPropDescription = {
	[SubscriptionProp.Description] : string | null
}
export type SubscriptionPropEndDate = {
	[SubscriptionProp.EndDate] : number | null
}
export type SubscriptionPropId = {
	[SubscriptionProp.Id] : number
}
export type SubscriptionPropModificationTime = {
	[SubscriptionProp.ModificationTime] : number | null
}
export type SubscriptionPropModifiedBy = {
	[SubscriptionProp.ModifiedBy] : models.UserDto | null
}
export type SubscriptionPropStatus = {
	[SubscriptionProp.Status] : 'ACTIVE' | 'PENDING' | 'INACTIVE' | null
}
export type SubscriptionPropSubscriptionDefinitionId = {
	[SubscriptionProp.SubscriptionDefinitionId] : number | null
}
export type SubscriptionPropSubscriptionDefinitionName = {
	[SubscriptionProp.SubscriptionDefinitionName] : string | null
}
export type SubscriptionPropSubscriptionDefinitionServiceType = {
	[SubscriptionProp.SubscriptionDefinitionServiceType] : 'SUBSCRIPTION' | 'SERVICE' | 'MARKETING_EMAILS' | null
}


export type Subscription = 
	SubscriptionPropCreatedBy & 
	SubscriptionPropCreationTime & 
	SubscriptionPropCustomer & 
	SubscriptionPropCustomerId & 
	SubscriptionPropDescription & 
	SubscriptionPropEndDate & 
	SubscriptionPropId & 
	SubscriptionPropModificationTime & 
	SubscriptionPropModifiedBy & 
	SubscriptionPropStatus & 
	SubscriptionPropSubscriptionDefinitionId & 
	SubscriptionPropSubscriptionDefinitionName & 
	SubscriptionPropSubscriptionDefinitionServiceType

export const SUBSCRIPTION_PROPERTY_NAMES = Object.freeze([SubscriptionProp.CreatedBy, SubscriptionProp.CreationTime, SubscriptionProp.Customer, SubscriptionProp.CustomerId, SubscriptionProp.Description, SubscriptionProp.EndDate, SubscriptionProp.Id, SubscriptionProp.ModificationTime, SubscriptionProp.ModifiedBy, SubscriptionProp.Status, SubscriptionProp.SubscriptionDefinitionId, SubscriptionProp.SubscriptionDefinitionName, SubscriptionProp.SubscriptionDefinitionServiceType])

export type SubscriptionTab = 
	SubscriptionPropId & 
	SubscriptionPropSubscriptionDefinitionName & 
	SubscriptionPropCustomerId

export const SUBSCRIPTION_TAB_PROPERTY_NAMES = Object.freeze([SubscriptionProp.Id, SubscriptionProp.SubscriptionDefinitionName, SubscriptionProp.CustomerId])

export type SubscriptionHistoryTab = 
	SubscriptionPropId & 
	SubscriptionPropSubscriptionDefinitionName

export const SUBSCRIPTION_HISTORY_TAB_PROPERTY_NAMES = Object.freeze([SubscriptionProp.Id, SubscriptionProp.SubscriptionDefinitionName])

export type SubscriptionHeader = 
	SubscriptionPropId & 
	SubscriptionPropSubscriptionDefinitionName & 
	SubscriptionPropStatus

export const SUBSCRIPTION_HEADER_PROPERTY_NAMES = Object.freeze([SubscriptionProp.Id, SubscriptionProp.SubscriptionDefinitionName, SubscriptionProp.Status])

export type SubscriptionInformation = 
	SubscriptionPropId & 
	SubscriptionPropCreationTime & 
	SubscriptionPropCreatedBy & 
	SubscriptionPropModificationTime & 
	SubscriptionPropModifiedBy & 
	SubscriptionPropCustomer & 
	SubscriptionPropSubscriptionDefinitionName & 
	SubscriptionPropSubscriptionDefinitionServiceType & 
	SubscriptionPropStatus & 
	SubscriptionPropEndDate & 
	SubscriptionPropDescription

export const SUBSCRIPTION_INFORMATION_PROPERTY_NAMES = Object.freeze([SubscriptionProp.Id, SubscriptionProp.CreationTime, SubscriptionProp.CreatedBy, SubscriptionProp.ModificationTime, SubscriptionProp.ModifiedBy, SubscriptionProp.Customer, SubscriptionProp.SubscriptionDefinitionName, SubscriptionProp.SubscriptionDefinitionServiceType, SubscriptionProp.Status, SubscriptionProp.EndDate, SubscriptionProp.Description])

export type SubscriptionCreate = 
	SubscriptionPropSubscriptionDefinitionId & 
	SubscriptionPropEndDate & 
	SubscriptionPropDescription

export const SUBSCRIPTION_CREATE_PROPERTY_NAMES = Object.freeze([SubscriptionProp.SubscriptionDefinitionId, SubscriptionProp.EndDate, SubscriptionProp.Description])
